import { useState } from 'react';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000';

type UploadFileToStorageInput = {
  file: File;
  clientId?: string;
  subfolder?: string;
};

export const useFileUploadMutation = () => {
  const [isLoading] = useState(false);
  const [isError] = useState(false);

  const uploadToFileStorage = async ({ file, clientId, subfolder }: UploadFileToStorageInput) => {
    const path = clientId ? `clients/${clientId}/pre-signed-upload-url` : 'pre-signed-upload-url';
    const response = await fetch(`${API_URL}/${path}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        fileName: file.name,
        subfolder,
      }),
      credentials: 'include',
    });

    if (!response.ok) {
      throw new Error('Failed to get pre-signed URL');
    }

    const data = await response.json();
    const { url } = data;

    // Upload the file to S3 using the pre-signed URL
    const uploadResponse = await fetch(url, {
      method: 'PUT',
      body: file,
      headers: {
        'Content-Type': file.type,
      },
    });

    if (!uploadResponse.ok) {
      throw new Error('Failed to upload file to S3');
    }
  };

  return {
    uploadToFileStorage,
    isLoading,
    isError,
  };
};
